<div class="copyright-section">
  @if (!isMobileSocialIcon) {
    <div class="footer">
      <ul class="footer__social-links__list" role="menu">
        @for (icon of socialIcons; track icon; let i = $index) {
          <li role="menuitem">
            <a
              class="footer__social-links__item {{ themeClass }}"
              rel="noopener, noreferrer"
              captureClicks
              data-link-type="social"
              [href]="icon.url"
              [attr?.data-link-name]="icon.name"
              >
              <mflooring-icon-button
                id="social_icon-{{ i }}"
						[presentation]="{
							size: 'small',
							type: 'icon-white',
							iconName: icon?.name,
							iconUrl: icon?.imgUrl
						}"
                class="main-header-search--icon"
              ></mflooring-icon-button>
            </a>
          </li>
        }
      </ul>
    </div>
  }
  <div class="copyright" >
    @if (!!copyright) {
      <p id="copyright">
        {{ copyright }}
      </p>
    }
  </div>

  @if (!isMobile) {
    <div class="footer-links">
      @if (!!termsOfUse?.url) {
        <a captureClicks [href]="termsOfUse?.url">
          {{ termsOfUse?.label }}
        </a>
      }
      @if (!!privacyPolicy?.url) {
        <a captureClicks [href]="privacyPolicy?.url">
          {{ privacyPolicy?.label }}
        </a>
      }
      @if (!!legalNotice?.url) {
        <a captureClicks [href]="legalNotice?.url">
          {{ legalNotice?.label }}
        </a>
      }
      @if (!!californiaDisclosures?.url) {
        <a captureClicks [href]="californiaDisclosures?.url">
          {{ californiaDisclosures.label }}
        </a>
      }
      @if (!!retailStores?.url) {
        <a captureClicks [href]="retailStores?.url">
          {{ retailStores.label }}
        </a>
      }
      @if (!isMobile) {
        <a captureClicks class=" cursor" (click)="openCookiesPopUp()"> Cookie Settings</a>
      }
      <!-- <a captureClicks [href]="patent?.url" *ngIf="!!patent?.url">
      {{ patent?.label }}
    </a> -->
  </div>
} @else {
  <div class="footer-links-mobile" >
    <div class="link-container">
      @if (!!termsOfUse?.url) {
        <a captureClicks [href]="termsOfUse?.url">
          {{ termsOfUse?.label }}
        </a>
      }
      @if (!!privacyPolicy?.url) {
        <a captureClicks [href]="privacyPolicy?.url">
          {{ privacyPolicy?.label }}
        </a>
      }
    </div>
    <div class="link-container">
      @if (!!legalNotice?.url) {
        <a captureClicks [href]="legalNotice?.url">
          {{ legalNotice?.label }}
        </a>
      }
      @if (!!californiaDisclosures?.url) {
        <a captureClicks [href]="californiaDisclosures?.url">
          {{ californiaDisclosures.label }}
        </a>
      }
      @if (!!retailStores?.url) {
        <a captureClicks [href]="retailStores?.url" id="flooring">
          {{ retailStores.label }}
        </a>
      }
      @if (isMobile) {
        <a captureClicks class="cursor" (click)="openCookiesPopUp()"> Cookie Settings</a>
      }
    </div>
    <!-- <a captureClicks [href]="patent?.url" *ngIf="!!patent?.url">
    {{ patent?.label }}
  </a> -->
</div>
}

</div>
